import styled from "@emotion/styled";

import { colors } from "../../colors";
import type { RadioGroupStyleProps } from "./types";

export const GroupContainer = styled.fieldset<{
  $direction: "vertical" | "horizontal";
  $disabled?: boolean;
  $styleProps?: RadioGroupStyleProps;
}>`
  border: 0;
  margin: 0;
  padding: 0;
  min-inline-size: 0;
  display: flex;
  flex-direction: column;
  gap: ${({ $styleProps }) => $styleProps?.gap || "8px"};
  opacity: ${({ $disabled }) => ($disabled ? 0.7 : 1)};
`;

export const GroupText = styled.legend<{ $styleProps?: RadioGroupStyleProps }>`
  font-size: ${({ $styleProps }) => $styleProps?.labelFontSize || "1.1em"};
  color: ${({ $styleProps }) => $styleProps?.labelColor || colors.gray[800]};
  margin-bottom: 4px;
`;

export const GroupDescription = styled.p<{
  $styleProps?: RadioGroupStyleProps;
}>`
  font-size: ${({ $styleProps }) => $styleProps?.descriptionFontSize || "1em"};
  color: ${({ $styleProps }) =>
    $styleProps?.descriptionColor || colors.gray[500]};
  margin: 0 0 4px 0;
`;

export const OptionsWrapper = styled.div<{
  $direction: "vertical" | "horizontal";
  $styleProps?: RadioGroupStyleProps;
}>`
  display: flex;
  flex-direction: ${({ $direction }) =>
    $direction === "vertical" ? "column" : "row"};
  gap: ${({ $direction, $styleProps }) => {
    if ($styleProps?.gap) {
      return $styleProps.gap;
    }
    return $direction === "vertical" ? "8px" : "16px";
  }};
  align-items: ${({ $direction }) =>
    $direction === "vertical" ? "stretch" : "center"};
`;
